import { AppAreaConfig } from '@/funnels/@types'
import female from '../fasting/female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-anti-inflammatory-diet',
	landing: {
		ids: ['loader-f-anti-inflammatory-diet'],
		route: {
			path: '/anti-inflammatory-diet-f',
			name: 'female-anti-inflammatory-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-anti-inflammatory-diet',
		route: {
			path: '/anti-inflammatory-diet-f/ob/:page*',
			name: 'female-anti-inflammatory-diet',
		},
		slug: 'female-anti-inflammatory-diet',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: female,
				page: 'target-zones',
			},
		},
	},
}

export default appAreaConfig
